/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
    DUMMY_BASE_URL,
    assertParamExists,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    serializeDataIfNeeded,
    toPathString,
    createRequestFunction,
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { WnstnTokenResponse } from '../models';
/**
 * WnstnApi - axios parameter creator
 * @export
 */
export const WnstnApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wnstnApiControllerGetToken: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/wnstn/levToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * WnstnApi - functional programming interface
 * @export
 */
export const WnstnApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = WnstnApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wnstnApiControllerGetToken(
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WnstnTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wnstnApiControllerGetToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};

/**
 * WnstnApi - factory interface
 * @export
 */
export const WnstnApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WnstnApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wnstnApiControllerGetToken(options?: any): AxiosPromise<WnstnTokenResponse> {
            return localVarFp.wnstnApiControllerGetToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WnstnApi - object-oriented interface
 * @export
 * @class WnstnApi
 * @extends {BaseAPI}
 */
export class WnstnApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WnstnApi
     */
    public wnstnApiControllerGetToken(options?: any) {
        return WnstnApiFp(this.configuration)
            .wnstnApiControllerGetToken(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
